import React from "react";
import {Tooltip,OverlayTrigger} from "react-bootstrap";
export default class RequestsListComponent extends React.Component{
  constructor(props){
    super(props);
    const {t} = props
    this.state = {
      tooltipText: <Tooltip id="tooltip">{t('revisedCost')}</Tooltip>,
      attachmentText: <Tooltip id="tooltip">{t('costPhotoExist')}</Tooltip>,
      cancellationRequestText: <Tooltip id="tooltip">{t('awaitingConfirmationForCancellation')}</Tooltip>,
    }
  }
  render(){
    var {user,data,infoButton,buttonsActions,manager,mstatus} = this.props;
    if(!data.revisions)
      data.revisions = []
    if(!data.cancellationRequest)
        data.cancellationRequest = {now:false};
    return(
      <tr>
        <td id="managerConfirmationUsername">
        {
        data.revisions.length > 0 ?  <OverlayTrigger placement="bottom" overlay={this.state.tooltipText}>
          <i className="fa fa-star star-color" aria-hidden="true"></i>
            </OverlayTrigger> : null}
       {
         data.costPhotos.length > 0 ?
         <OverlayTrigger placement="bottom" overlay={this.state.attachmentText}>
            <i className="fa fa-paperclip star-color" aria-hidden="true"></i>
        </OverlayTrigger>
      :
      null
      }
      { data.cancellationRequest.now ? <OverlayTrigger placement="bottom" overlay={this.state.cancellationRequestText}>
        <i className="fa fa-ban star-color" aria-hidden="true"></i>
      </OverlayTrigger> : null }

  {user.employeeName}</td>
        <td id="managerConfirmationInvoiceNo">{data.invoiceNo}</td>
        <td id="managerConfirmationCostType">{data.costType}</td>
        <td id="managerConfirmationCostDate">{data.costDate}</td>
        <td id="managerConfirmationCreatedDate">{data.costCreatedDate}</td>
        <td id="managerConfirmationCostAmount">{data.costAmount} {new window.Money(data.moneyType).getMoneySymbol()}</td>
        <td id="managerConfirmationCostButtons">
          <button type="button"id="managerConfirmationCostInfoButton" onClick={() => {infoButton(user,data)}} className="btn btn-wd btn-info btn-fill btn-rotate actionBtn"><span className="btn-label"><i className="fa fa-info"></i></span></button>
          &nbsp;
            <div style={{display: mstatus == "manager"  ? "inline-block" : "none" }}>
              <button type="button" id="managerConfirmationCostSuccessButton" onClick={() => {buttonsActions[0](false,user,data)}} className="btn btn-wd btn-success actionBtn">
                <span className="btn-label"><i className="fa fa-check"></i></span>
                </button>
                <span>&nbsp;</span>
                <button type="button" id="managerConfirmationCostDangerButton" onClick={() => {buttonsActions[1](user,data)}} className="btn btn-wd btn-danger actionBtn">
                  <span className="btn-label"><i className="fa fa-times"></i></span>
                  </button>
            </div>

            {
            data.transactions
            ?
            <span>
              &nbsp;
              <button type="button" id="managerConfirmationCostTransactionsButton" onClick={() => {this.props.transactionsButton(user,data)}} className="btn btn-wd btn-default actionBtn">
                <span className="btn-label"><i className="fa fa-cogs"></i></span>
                </button>
            </span>
            :
            null
          }
      </td>
      </tr>
    )
  }
}
